import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import AddDocumentControl from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/StagesSection/AddDocumentControl';
import StageCard from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/StagesSection/StageCard';
import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import SectionCard from '@Guidelines/Component/SectionCard';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const errorStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: 0.78125rem;
	font-weight: ${theme.fontWeights.medium};
	line-height: 1.5;
	color: ${theme.states.danger.solid};
`;

/** The ordered stages of the group, each holding the documents produced in parallel. */
const StagesSection: React.FC = () => {
	const { draft } = useWorkflowDraft();
	const stagesMessage = draft.getValidationMessage('stages');

	return (
		<SectionCard
			title="Étapes"
			description="Dans l’ordre. Les documents d’une même étape sont générés en parallèle."
		>
			{draft.stages.map((stage, stageIndex) => (
				<StageCard
					// biome-ignore lint/suspicious/noArrayIndexKey: a stage has no identity besides its rank
					key={stageIndex}
					stageIndex={stageIndex}
					stage={stage}
				/>
			))}
			<ConditionalLoader data={!draft.isValid('stages')}>
				<p css={errorStyle} role="alert">
					{stagesMessage}
				</p>
			</ConditionalLoader>
			<AddDocumentControl stageIndex={null} />
		</SectionCard>
	);
};

export default StagesSection;
